/* -*- Mode: javascript; indent-tabs-mode: nil; c-basic-offset: 2 -*- */

(function() {
  /* jshint validthis: true, newcap: false */
  'use strict';

  /**
   * sgAvatarImage - An avatar directive that returns un img element with either a local URL (if sg-src is specified)
   * or a Gravatar URL built from the Gravatar factory.
   * Based on http://blog.lingohub.com/2014/08/better-ux-with-angularjs-directives/.
   * @memberof SOGo.Common
   * @example:
     <sg-avatar-image sg-email="test@email.com" size="50"></sg-avatar-image>
  */
  function sgGenericAvatarImage() {
    return {
      restrict: 'A',
      scope: {},
      bindToController: {
        size: '@',
        email: '=sgEmail',
        src: '=sgSrc'
      },
      //transclude: true,
      template: '<img ng-src="{{vm.url()}}" />',
      //template: '<div class="md-avatar" ng-transclude></div>',
      //template: '<img ng-src="https://www.gravatar.com/avatar/{{vm.email}}?s={{vm.size}}&d=404" alt="{{vm.email}}"/>',
      link: link,
      //bindToController: true,
      controller: 'sgAvatarImageController',
      controllerAs: 'vm'
    };
  }

  function link(scope, element, attrs, controller) {
    var el = element[0],
        imgElement = element.find('img'),
        img = imgElement[0];

    if (attrs.size) {
      imgElement.attr('width', attrs.size);
      imgElement.attr('height', attrs.size);
    }

    //imgElement.attr('src', controller.url());
    
    imgElement.on('error', function() {
      // Error while loading external link; insert a generic avatar
      imgElement.off('error');
      console.error('error with ' + controller.email);
      controller.insertGenericAvatar(img);
    });
  }

  /**
   * @ngInject
   */
  sgAvatarImageController.$inject = ['$scope', '$element', 'Preferences', 'Gravatar'];
  function sgAvatarImageController($scope, $element, Preferences, Gravatar) {
    var vm = this, deregisterEmailWatch, deregisterSrcWatch;

    /*
    deregisterEmailWatch = $scope.$watch('vm.email', function(email) {

      Preferences.ready().then(function() {
        var img = $element.find('img')[0];
        if (!email && !vm.genericAvatar) {
          // If no email is specified, insert a generic avatar
          vm.insertGenericAvatar(img);
        }
        else if (email) {// && !vm.url) {
          if (vm.genericAvatar) {
            // Remove generic avatar and restore visibility of image
            vm.genericAvatar.parentNode.removeChild(vm.genericAvatar);
            vm.genericAvatar = null;
            img.classList.remove('ng-hide');
            console.debug('remove generic avatar');
          }
          vm.url = Gravatar(email, vm.size, Preferences.defaults.SOGoAlternateAvatar);
          //deregisterEmailWatch();
          console.debug('load ' + email + ' => ' + vm.url);
        }
      });
    });

    // If sg-src is defined, watch the expression for the URL of a local image
    if ('sg-src' in $element[0].attributes) {
      deregisterSrcWatch = $scope.$watch('vm.src', function(src) {
        if (src) {
          vm.url = src;
          deregisterSrcWatch();
        }
      });
    }
    */

    vm.url = function() {
      if (vm.email)
        return Gravatar(vm.email, vm.size, Preferences.defaults.SOGoAlternateAvatar);
    };
    
    vm.insertGenericAvatar = function(img) {
      var avatar;

      if (!vm.genericAvatar) {
        avatar = document.createElement('md-icon');
        avatar.className = 'material-icons icon-person';
        img.classList.add('ng-hide');
        vm.genericAvatar = img.parentNode.insertBefore(avatar, img);
      }
    };
  }

  angular
    .module('SOGo.Common')
    .directive('sgGenericAvatarImage', sgGenericAvatarImage);
    // .controller('sgAvatarImageController', sgAvatarImageController);
})();
